import { render, staticRenderFns } from "./model-add-or-update.vue?vue&type=template&id=93e73d5c&"
import script from "./model-add-or-update.vue?vue&type=script&lang=js&"
export * from "./model-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports